import { call } from 'redux-saga/effects';
import watch from 'redux-watch';
import { generate } from '../utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { debug, error } from '../utils/logger';

import {
    genericEmailServiceSaga
} from "../sagas/genericEmailServiceSaga";

import {
    genericEmailServiceSuccess,
    genericEmailServiceError,
    saveGenericEmailValidation
} from "../actions/genericEmailServiceActions";

import {
    checkForm,
    shouldActivateParsley
} from '../utils/errorHandling';

import {
    scrollToElement
} from '../utils/scrollUtils';

import { getOptionsForUpdateButton } from '../../../core/js/utils/requestUtils';

import { handleUtagEvent } from '../actions/initialActions.js';

import { updateButtonTextSaga } from '../sagas/animateButtonSagas';

import {
    setSelectedCountry,
    setGroupTypeForSelectedCountry,
    setGroupType
} from '../actions/countrySelectActions';

import {
    getGroupTypeForSelectedCountry,
    getGroupTypeByCountry
 } from '../utils/validationUtils';

/**
 * Bootstrap the component onto the page
 * @param {object} store The store
 * @param {object} overrides overrides
 * @returns {undefined}
 */
export function init(store, overrides = {}){
    const config = {
        name: 'genericEmailServiceComponent',
        template: 'override_me',
        watch: ['core.genericEmailService', 'core.validations'],
        templateLocation: '.dom-generic-email-service',
        firstRender: firstRender,
        attachEvents: attachEvents,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), '.js-generic-email-form', (e) => {
        e.preventDefault();

        if ($(e.target).hasClass('js-generic-email-override')) { return false; }

        const formSlug = $(e.target).attr('data-form-slug');
        const formData = $(e.target).serializeArray();
        const formElement = '.js-generic-email-form';
        const templateElement = '.dom-generic-email-service';

        const updateOptions = getOptionsForUpdateButton(store);

        const res = store.runSaga(updateButtonTextSaga, call(genericEmailServiceSaga, formData, formSlug), '.js-generic-email-submit', 2000, updateOptions)
            .done.then(() => {
                store.dispatch(genericEmailServiceSuccess());
                $(formElement).trigger('reset');
                scrollToElement(templateElement);
                store.dispatch(handleUtagEvent({ event_name: formSlug }, 'link'));
            }).catch(err => {
                store.dispatch(genericEmailServiceError(`ERROR_GENERIC_EMAIL_${formSlug.replace(/-/g, '_').toUpperCase()}_SUBMIT_ERROR`));
                scrollToElement(templateElement);
                error(err);
            });
    });
}

export function attachParsley(component, store) {
    const formSelector = component.scopedSelector('.js-generic-email-form');
    const formElement = $(formSelector);
    const parsleyForm = formElement.parsley();

    function activateValidation() {
        const [values, msgs] = checkForm(formSelector);
        store.dispatch(saveGenericEmailValidation(values, msgs));
    }

    function activateFieldValidation() {
        if (parsleyForm) {
            parsleyForm.on('field:validated', (e) => {
                activateValidation();
            });
        }
    }

    // sometimes this is undefined, like when clicking the previous button on request a swatch
    if (parsleyForm) {
        activateFieldValidation();

        parsleyForm.on('form:validate', (e) => {
            if (parsleyForm) {
                parsleyForm.off('field:validated');
            }
        });

        parsleyForm.on('form:validated', (e) => {
            activateValidation();
            activateFieldValidation();
        });
    }
}

function setFormValidationRulesForUk(store) {
    const state = store.getState();
    const selectedCountryCode = 'GB';
    const groupType = getGroupTypeByCountry(state, selectedCountryCode);

    store.dispatch(setGroupType(groupType));
    store.dispatch(setSelectedCountry(selectedCountryCode));
    store.dispatch(setGroupTypeForSelectedCountry(getGroupTypeForSelectedCountry(groupType)));
}

function firstRender(store) {
    const state = store.getState();
    this.onStateChange(store);

    if (shouldActivateParsley('.js-generic-email-form')) {
        attachParsley(this, store);

        const groupType = getGroupTypeByCountry(state, 'US');
        store.dispatch(setGroupTypeForSelectedCountry(getGroupTypeForSelectedCountry(groupType)));

        if (state.core.siteId === 'an-uk') {
            setFormValidationRulesForUk(store);
        }

    }
}
